import React, { useContext } from "react";
import {
  Caption,
  Card,
  TextField,
  Checkbox,
  Stack,
  ColorPicker,
  Layout,
  Button,
  Collapsible,
  TextContainer,
  TextStyle,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ButtonColor = () => {
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { COPY, IS_HEADER_COPY, BUTTON, HEX, DEFAULT_BUTTON_COLOR, COLOR } = constant;
  const {
    color = {},
    errorMessage = {},
    handleChange = () => {},
    hex = {},
    isHeaderCopy = false,
    // learnMore = () => {},
    resetDefault = () => {},
  } = useContext(BrandingContext);

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.buttonColor.title")}
        description={cms("section.buttonColor.description")}
      >
        <Card
          title={[
            cms("section.buttonColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.buttonColor.title"), "TODO: ") }]}
        >
          <Card.Section>
            <TextContainer>{cms("section.buttonColor.subDescription")}</TextContainer>
            <br />
            <Checkbox
              label={cms("section.buttonColor.label.useSameColor")}
              checked={isHeaderCopy}
              onChange={(value) => handleChange(IS_HEADER_COPY, value, COPY)}
            />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.buttonColor.label.hexCode")}
                  value={hex.buttonHex}
                  onChange={(value) => handleChange(BUTTON, value, HEX)}
                  labelAction={
                    hex.buttonHex !== DEFAULT_BUTTON_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(BUTTON, DEFAULT_BUTTON_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.button}
                />
                <br />
                <Button primary>{cms("section.buttonColor.label.sampleButton")}</Button>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker onChange={(value) => handleChange(BUTTON, value, COLOR)} color={color.button} />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(ButtonColor), {
  feature: constant.STANDARD_BRANDING,
});
